import React, { useState, useEffect } from "react";
import styles from "./WorkBagForm.module.scss";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import PDF from "../../components/Footer/PDF/Terminos-y-condiciones-edify-2021.pdf";
import { ReactComponent as CheckIcon } from "../../assets/svg/check-white.svg";
import { getCities } from '../../store/actions';
import { connect } from "react-redux";
import { UserRound, Briefcase, MapPin, ClipboardList, ChevronDown, Check, X, Mail, Phone } from "lucide-react";
import { JURISDICTIONS } from '../../constants/jurisdictions.ts';

const variants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  }
  
  const WorkBagForm = React.memo(({ formik, skills, cities, today, isPhone, setShowForm, getCities }) => {
    const [showJurisdictionList, setShowJurisdictionList] = useState(false)
    const [showCityList, setShowCityList] = useState(false)
    const [showSkillsList, setShowSkillsList] = useState(false)
    const [showSuggestions, setShowSuggestions] = useState(false)

    const [onHover, setOnHover] = useState("")
    const [showCitySuggestions, setShowCitySuggestions] = useState(false)
    const [cityInputValue, setCityInputValue] = useState("")
    const [inputValue, setInputValue] = useState("")
  
    const jurisdictionArray = JURISDICTIONS;
  
    const handleAddSkill = (skillName, skillId) => {
      const skillExists = formik.values.skills.some((skill) => skill.id === skillId)
      if (!skillExists) {
        formik.setFieldValue("skills", [...formik.values.skills, { id: skillId, name: skillName }])
      }
      setShowSkillsList(false)
      setShowSuggestions(false)
      setInputValue("")
    }
  
    const handleSuggestions = (value) => {
      if (value.length < 3) {
        setShowSuggestions(false)
      } else if (value.length >= 3) {
        setShowSkillsList(false)
        setShowSuggestions(true)
      }
      setInputValue(value)
    }
  
    const matchingSkills = skills?.filter((rubro) => {
      return rubro.name.toLowerCase().includes(inputValue.toLowerCase())
    })
  
    const handleCitySuggestions = (value) => {
      if (value.length < 3) {
        setShowCitySuggestions(false)
      } else if (value.length >= 3) {
        setShowCityList(false)
        setShowCitySuggestions(true)
      }
      setCityInputValue(value)
    }
  
    const matchingCities = cities?.filter((city) => {
      return city.name.toLowerCase().includes(cityInputValue.toLowerCase())
    })
  
    const selectedJurisdictionId = formik.values.selectedJurisdiction?.id
    useEffect(() => {
      if (formik.values.selectedJurisdiction) {
        getCities(selectedJurisdictionId)
      }
    }, [selectedJurisdictionId])
  
    const convertDateToISOFormat = (date) => {
      const [dd, mm, yyyy] = date.split("/")
      return `${yyyy}-${mm}-${dd}`
    }
  
    const handleMouseEnter = (index) => setOnHover(index)
    const handleMouseLeave = () => setOnHover("")
    const handleTouchStart = (index) => setOnHover(index)
    const handleTouchEnd = () => setOnHover("")
  
    const isSkillSelected = (skill) => {
      return formik.values.skills?.some((s) => s.id === skill.id) || false
    }
  
    const removeSkill = (skillToRemove) => {
      const newSkills = formik.values.skills.filter((skill) => skill.id !== skillToRemove.id)
      formik.setFieldValue("skills", newSkills)
    }
  
    return (
      <motion.div variants={variants} initial="hidden" animate="visible" exit="hidden" className={styles.workBag}>
        <div className={styles.workBag_main}>
          <form onSubmit={formik.handleSubmit} className={styles.workBag_form}>
            <div className={styles.section}>
              <h2 className={styles.workBag_subtitle}>
                <UserRound className={styles.workBag_formIcon} />
                Datos personales
              </h2>
  
              <div className={styles.formGroup}>
                <div className={styles.formGroup_textInputContainer}>
                  <label htmlFor="name" className={styles.formGroup_label}>
                    Nombre
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder={formik.errors.name ? formik.errors.name : "Tu nombre"}
                    className={`${styles.workBag_input} ${formik.errors.name && styles.error}`}
                    onChange={formik.handleChange}
                    value={formik.values.name}
                  />
                </div>
                <div className={styles.formGroup_textInputContainer}>
                  <label htmlFor="lastname" className={styles.formGroup_label}>
                    Apellido
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    name="lastname"
                    placeholder={formik.errors.lastname ? formik.errors.lastname : "Tu apellido"}
                    className={`${styles.workBag_input} ${formik.errors.lastname && styles.error}`}
                    onChange={formik.handleChange}
                    value={formik.values.lastname}
                  />
                </div>
              </div>
  
              <div className={styles.formGroup}>
                <div className={styles.formGroup_textInputContainer}>
                  <label htmlFor="email" className={styles.formGroup_label}>
                    Email
                  </label>
                  <div className={styles.inputWithIcon}>
                    <Mail className={styles.inputIcon} />
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder={formik.errors.email ? formik.errors.email : "tu@email"}
                      className={`${styles.workBag_input} ${styles.inputWithIconPadding} ${formik.errors.email && styles.error}`}
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                  </div>
                </div>
                <div className={styles.formGroup_textInputContainer}>
                  <label htmlFor="phone" className={styles.formGroup_label}>
                    Teléfono
                  </label>
                  <div className={styles.inputWithIcon}>
                    <Phone className={styles.inputIcon} />
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      placeholder={formik.errors.phone ? formik.errors.phone : "(011) 1234-5678"}
                      className={`${styles.workBag_input} ${styles.inputWithIconPadding} ${formik.errors.phone && styles.error}`}
                      onChange={formik.handleChange}
                      value={formik.values.phone}
                    />
                  </div>
                </div>
              </div>
            </div>
  
            <div className={styles.section}>
              <h2 className={styles.workBag_subtitle}>
                <Briefcase className={styles.workBag_formIcon} />
                Areas de trabajo
              </h2>
  
              <div
                className={styles.formGroup_skills}
                onMouseEnter={() => handleMouseEnter(1)}
                onMouseLeave={handleMouseLeave}
                onTouchStart={() => handleTouchStart(1)}
                onTouchEnd={handleTouchEnd}
              >
                {onHover === 1 && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className={styles.workBag_infoContainer}
                  >
                    <p className={styles.workBag_infoText}>
                      Seleccioná los rubros en los que te desempeñás, podés elegir más de 1.
                    </p>
                  </motion.div>
                )}
  
                {formik.values.skills.length > 0 && (
                  <div className={styles.selectedItems}>
                    {formik.values.skills.map((skill, index) => (
                      <div key={index} className={styles.selectedItem}>
                        <span className={styles.selectedItemText}>{skill.name}</span>
                        <button type="button" className={styles.selectedItemRemove} onClick={() => removeSkill(skill)}>
                          <X size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
  
                <div className={styles.customDropdown}>
                  <div className={`${styles.workBag_workZoneContainer} ${formik.errors.skills && styles.error}`}>
                    <input
                      type="text"
                      id="skills"
                      name="skills"
                      placeholder={
                        formik.errors.skills ? formik.errors.skills : "Ingresá 3 caracteres para ver sugerencias"
                      }
                      value={inputValue}
                      className={`${styles.workBag_workZoneContainer_input} ${formik.errors.skills && styles.error}`}
                      onChange={(e) => handleSuggestions(e.target.value)}
                    />
                    <ChevronDown
                      className={`${styles.dropdownIcon} ${showSkillsList ? styles.dropdownIconOpen : ""}`}
                      onClick={() => setShowSkillsList(!showSkillsList)}
                    />
                  </div>
  
                  {showSkillsList && !showSuggestions && (
                    <div className={styles.dropdownMenu}>
                      {skills.map((skill, index) => (
                        <div
                          key={index}
                          className={`${styles.dropdownItem} ${isSkillSelected(skill) ? styles.dropdownItemSelected : ""}`}
                          onClick={() => handleAddSkill(skill.name, skill.id)}
                        >
                          <span className={styles.dropdownItemText}>{skill.name}</span>
                          {isSkillSelected(skill) && <Check className={styles.dropdownItemCheck} />}
                        </div>
                      ))}
                    </div>
                  )}
  
                  {showSuggestions && !showSkillsList && (
                    <div className={styles.dropdownMenu}>
                      {matchingSkills.map((suggestion, index) => (
                        <div
                          key={index}
                          className={`${styles.dropdownItem} ${isSkillSelected(suggestion) ? styles.dropdownItemSelected : ""}`}
                          onClick={() => handleAddSkill(suggestion.name, suggestion.id)}
                        >
                          <span className={styles.dropdownItemText}>{suggestion.name}</span>
                          {isSkillSelected(suggestion) && <Check className={styles.dropdownItemCheck} />}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
  
            <div className={styles.section}>
              <h2 className={styles.workBag_subtitle}>
                <MapPin className={styles.workBag_formIcon} />
                Lugares donde estás dispuesto a trabajar
              </h2>
  
              <div
                className={styles.formGroup_workZone}
                onMouseEnter={() => handleMouseEnter(2)}
                onMouseLeave={handleMouseLeave}
                onTouchStart={() => handleTouchStart(2)}
                onTouchEnd={handleTouchEnd}
              >
                {onHover === 2 && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className={styles.workBag_infoContainer}
                  >
                    <p className={styles.workBag_infoText}>
                      Elegí la provincia y la ciudad donde estás dispuesto a trabajar, podés elegir más de 1.
                    </p>
                  </motion.div>
                )}
  
                {formik.values.workZone.length > 0 && (
                  <div className={styles.selectedItems}>
                    {formik.values.workZone.map((workZone, index) => (
                      <div key={index} className={styles.selectedItem}>
                        <span className={styles.selectedItemText}>
                          {workZone.name} - {workZone.city.split(",")[0]}
                        </span>
                        <button
                          type="button"
                          className={styles.selectedItemRemove}
                          onClick={() => {
                            formik.setFieldValue(
                              "workZone",
                              formik.values.workZone.filter((_, i) => i !== index),
                            )
                          }}
                        >
                          <X size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
  
                <div className={styles.formGroup_workZone_inputsContainer}>
                  <div className={styles.inputWrapper}>
                    {isPhone ? (
                      <select
                        name="province"
                        value={formik.values.selectedJurisdiction?.id || ""}
                        onChange={(e) => {
                          const province = jurisdictionArray?.find((j) => j.id === Number.parseInt(e.target.value))
                          if (province) {
                            formik.setFieldValue("selectedJurisdiction", {
                              id: province.id,
                              name: province.name,
                            })
                          }
                        }}
                        className={`${styles.select} ${formik.values.workZone.length === 0 && !formik.isValid ? styles.error : ""}`}
                      >
                        <option value="">Seleccionar provincia</option>
                        {jurisdictionArray?.map((jurisdiction) => (
                          <option key={jurisdiction.id} value={jurisdiction.id}>
                            {jurisdiction.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div className={styles.customDropdown}>
                        <div
                          className={`${styles.workBag_workZoneContainer} ${formik.values.workZone.length === 0 && !formik.isValid ? styles.error : ""}`}
                        >
                          <input
                            type="text"
                            id="jurisdictionList"
                            name="jurisdictionList"
                            placeholder={
                              formik.values.workZone.length === 0 && !formik.isValid
                                ? formik.errors.workZone
                                : "Elegir provincia"
                            }
                            className={`${styles.workBag_workZoneContainer_input} ${formik.values.workZone.length === 0 && !formik.isValid ? styles.error : ""}`}
                            value={formik.values.selectedJurisdiction?.name || ""}
                            readOnly
                          />
                          <ChevronDown
                            className={`${styles.dropdownIcon} ${showJurisdictionList ? styles.dropdownIconOpen : ""}`}
                            onClick={() => setShowJurisdictionList(!showJurisdictionList)}
                          />
                        </div>
  
                        {showJurisdictionList && (
                          <div className={styles.dropdownMenu}>
                            {jurisdictionArray.map((jurisdiction) => (
                              <div
                                key={jurisdiction.id}
                                className={`${styles.dropdownItem} ${formik.values.selectedJurisdiction?.id === jurisdiction.id ? styles.dropdownItemSelected : ""}`}
                                onClick={() => {
                                  formik.setFieldValue("selectedJurisdiction", {
                                    id: jurisdiction.id,
                                    name: jurisdiction.name,
                                  })
                                  setShowJurisdictionList(false)
                                }}
                              >
                                <span className={styles.dropdownItemText}>{jurisdiction.name}</span>
                                {formik.values.selectedJurisdiction?.id === jurisdiction.id && (
                                  <Check className={styles.dropdownItemCheck} />
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
  
                  <div className={styles.inputWrapper}>
                    {isPhone ? (
                      <select
                        name="city"
                        value={cityInputValue}
                        onChange={(e) => {
                          const cityName = e.target.value
                          if (cityName) {
                            const isCityDuplicate = formik.values.workZone.some(
                              (zone) =>
                                zone.city === cityName && zone.jurisdiccion === formik.values.selectedJurisdiction.id,
                            )
  
                            if (!isCityDuplicate) {
                              const newWorkZone = [
                                ...formik.values.workZone,
                                {
                                  jurisdiccion: formik.values.selectedJurisdiction.id,
                                  name: formik.values.selectedJurisdiction.name,
                                  city: cityName,
                                },
                              ]
  
                              formik.setFieldValue("workZone", newWorkZone)
                              formik.setFieldValue("city", cityName)
                              formik.setFieldValue("selectedJurisdiction", null)
                              setCityInputValue("")
                            }
                          }
                        }}
                        disabled={!formik.values.selectedJurisdiction}
                        className={`${styles.select} ${!formik.values.selectedJurisdiction ? styles.selectDisabled : ""}`}
                      >
                        <option value="">Seleccionar ciudad</option>
                        {cities?.map((city, index) => (
                          <option key={index} value={city.name}>
                            {city.name}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <div className={styles.customDropdown}>
                        <div
                          className={`${styles.workBag_workZoneCityContainer} ${!formik.values.selectedJurisdiction ? styles.disabledInput : ""}`}
                        >
                          <input
                            type="text"
                            id="cityList"
                            name="cityList"
                            placeholder="Elegir ciudad"
                            value={cityInputValue}
                            onChange={(e) => handleCitySuggestions(e.target.value)}
                            className={`${styles.workBag_workZoneInput} ${!formik.values.selectedJurisdiction ? styles.disabledInput : ""}`}
                          />
                          <ChevronDown
                            className={`${styles.dropdownIcon} ${showCityList ? styles.dropdownIconOpen : ""} ${!formik.values.selectedJurisdiction ? styles.disabledInput : ""}`}
                            onClick={() => setShowCityList(!showCityList)}
                          />
                        </div>
  
                        {showCityList && !showCitySuggestions && (
                          <div className={styles.dropdownMenu}>
                            {cities?.map((city, index) => (
                              <div
                                key={index}
                                className={styles.dropdownItem}
                                onClick={() => {
                                  const isCityDuplicate = formik.values.workZone.some(
                                    (zone) =>
                                      zone.city === city.name &&
                                      zone.jurisdiccion === formik.values.selectedJurisdiction.id,
                                  )
  
                                  if (!isCityDuplicate) {
                                    const newWorkZone = [
                                      ...formik.values.workZone,
                                      {
                                        jurisdiccion: formik.values.selectedJurisdiction.id,
                                        name: formik.values.selectedJurisdiction.name,
                                        city: city.name,
                                      },
                                    ]
  
                                    formik.setFieldValue("workZone", newWorkZone)
                                    formik.setFieldValue("city", city.name)
                                    formik.setFieldValue("selectedJurisdiction", null)
                                    setShowCityList(false)
                                    setShowCitySuggestions(false)
                                    setCityInputValue("")
                                  }
                                }}
                              >
                                <span className={styles.dropdownItemText}>{city.name}</span>
                              </div>
                            ))}
                          </div>
                        )}
  
                        {showCitySuggestions && !showCityList && (
                          <div className={styles.dropdownMenu}>
                            {matchingCities.map((city) => (
                              <div
                                key={city.name}
                                className={styles.dropdownItem}
                                onClick={() => {
                                  const newWorkZone = [
                                    ...formik.values.workZone,
                                    {
                                      jurisdiccion: formik.values.selectedJurisdiction.id,
                                      name: formik.values.selectedJurisdiction.name,
                                      city: city.name,
                                    },
                                  ]
                                  formik.setFieldValue("workZone", newWorkZone)
                                  formik.setFieldValue("city", city.name)
                                  formik.setFieldValue("selectedJurisdiction", null)
                                  formik.setFieldValue("city", "")
                                  setShowCityList(false)
                                  setShowCitySuggestions(false)
                                  setCityInputValue("")
                                }}
                              >
                                <span className={styles.dropdownItemText}>{city.name}</span>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
  
            <div className={styles.section}>
              <h2 className={styles.workBag_subtitle}>
                <ClipboardList className={styles.workBag_formIcon} />
                Situación laboral
              </h2>
  
              <div className={styles.radioGroup}>
                <div className={styles.radioItem}>
                  <span className={styles.radioLabel}>¿Posee libreta de fondo de desempleo?</span>
                  <div className={styles.radioOptions}>
                    <label className={styles.radioOption}>
                      <input
                        type="radio"
                        name="unemploymentFund"
                        value="true"
                        checked={formik.values.unemploymentFund === true}
                        onChange={() => formik.setFieldValue("unemploymentFund", true)}
                      />
                      <span className={styles.radioCustom}></span>
                      Sí
                    </label>
                    <label className={styles.radioOption}>
                      <input
                        type="radio"
                        name="unemploymentFund"
                        value="false"
                        checked={formik.values.unemploymentFund === false}
                        onChange={() => formik.setFieldValue("unemploymentFund", false)}
                      />
                      <span className={styles.radioCustom}></span>
                      No
                    </label>
                  </div>
                  {formik.errors.unemploymentFund && formik.touched.unemploymentFund && (
                    <span className={styles.errorText}>{formik.errors.unemploymentFund}</span>
                  )}
                </div>
  
                <div className={styles.radioItem}>
                  <span className={styles.radioLabel}>¿Tiene trabajo actualmente?</span>
                  <div className={styles.radioOptions}>
                    <label className={styles.radioOption}>
                      <input
                        type="radio"
                        name="currentJob"
                        value="true"
                        checked={formik.values.currentJob === true}
                        onChange={() => formik.setFieldValue("currentJob", true)}
                      />
                      <span className={styles.radioCustom}></span>
                      Sí
                    </label>
                    <label className={styles.radioOption}>
                      <input
                        type="radio"
                        name="currentJob"
                        value="false"
                        checked={formik.values.currentJob === false}
                        onChange={() => formik.setFieldValue("currentJob", false)}
                      />
                      <span className={styles.radioCustom}></span>
                      No
                    </label>
                  </div>
                  {formik.errors.currentJob && formik.touched.currentJob && (
                    <span className={styles.errorText}>{formik.errors.currentJob}</span>
                  )}
                </div>
  
                {formik.values.currentJob && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.5 }}
                    className={styles.inputWrapper}
                  >
                    <label htmlFor="employmentEndDate" className={styles.dateLabel}>
                      Fecha aprox. de finalización de empleo
                    </label>
                    <input
                      type="date"
                      id="employmentEndDate"
                      name="employmentEndDate"
                      min={convertDateToISOFormat(today)}
                      className={`${styles.workBag_input} ${formik.errors.employmentEndDate ? styles.error : ""}`}
                      onChange={formik.handleChange}
                      value={formik.values.employmentEndDate}
                    />
                    {formik.errors.employmentEndDate && (
                      <span className={styles.errorText}>{formik.errors.employmentEndDate}</span>
                    )}
                  </motion.div>
                )}
              </div>
            </div>
  
            <div className={styles.section}>
              <label className={styles.checkboxWrapper}>
                <input
                  id="termsAndConditions"
                  name="termsAndConditions"
                  type="checkbox"
                  onChange={formik.handleChange}
                  className={styles.checkboxInput}
                />
                <span className={styles.checkboxCustom}>{formik.values.termsAndConditions && <Check size={14} />}</span>
                <span className={styles.checkboxLabel}>
                  Acepto los{" "}
                  <Link to={PDF} className={styles.link} target="_blank" download>
                    Términos y Condiciones*
                  </Link>
                </span>
              </label>
              {formik.touched.termsAndConditions && formik.errors.termsAndConditions && (
                <span className={styles.errorText}>{formik.errors.termsAndConditions}</span>
              )}
            </div>
  
            <div className={styles.buttonsContainer}>
              <button
                className={styles.submitButton}
                type="submit"
                disabled={!formik.isValid || !formik.dirty || formik.isSubmitting}
              >
                <CheckIcon className={styles.checkIcon} />
                {formik.isSubmitting ? "Enviando..." : "Enviar"}
              </button>
            </div>
  
            {isPhone && (
              <div className={styles.buttonsContainer}>
                <button type="button" onClick={() => setShowForm(false)} className={styles.secondaryButton}>
                  Ver búsquedas abiertas
                </button>
              </div>
            )}
          </form>
        </div>
      </motion.div>
    )
  });
  
  const mapStateToProps = (state) => {
    return {
      cities: state.register.cities,
    }
  }
  
  const WorkBagFormConnected = connect(mapStateToProps, { getCities })(WorkBagForm)
  
  export default WorkBagFormConnected